import _ from 'lodash';
import moment from 'moment';
import { getDateFormat } from '../../utils/suitableDate';
import {
  DISHOP,
  NETWORK,
  SHOP,
  PAYMENT,
  PAYMENT_TYPE_STRIPE,
  PAYMENT_TYPE_CB,
  DRIVER
} from '../../constants/dataConfig';
import { isObjectNotEmpty, isIntegerNotNull, removeEmptyStringsFromObject } from '../../utils/tools';
import { getFirstAndLastDate } from '../../utils/billingUtils';
import { ORDER_REFUND } from '../../constants';

// Periode de facturation de la forme 'debut - fin'
export const renderPeriodeFacturation = (date, year) => {
  const { month, quinzaine } = date;
  const lastDay =
    quinzaine === '16'
      ? moment(`${year}-${month}-${quinzaine}`)
        .endOf('month')
        .get('date')
      : '15';
  return ` ${getDateFormat(`${year}-${month}-${quinzaine}`)} - ${getDateFormat(
    `${year}-${month}-${lastDay}`
  )}`;
};
// Rend une clef unique par facture du la forme 'jourMoisAnsShopId', avec comme date celle d'emission
export const renderKeyFacture = props => {
  const { billings, dateInfo, year, shopId, isNetworkChecked, isDriverInvoice } = props;
  const invoiceType = isNetworkChecked ? NETWORK : SHOP;
  const { month, quinzaine } = dateInfo;
  const { lastDate } = getFirstAndLastDate(quinzaine, month, year);
  return ` ${getDateFormat(isDriverInvoice ? dateInfo : lastDate, 'DDMMYYYY')}${isDriverInvoice ? billings.orderNumber : ''
    }${shopId.toUpperCase()}${invoiceType.toUpperCase()}`;
};

// La date d'émission et la date d'émission de la facture, elle est rendu disponible pour le client car la période est cloturé
export const renderEmissionDate = (date, year, isDriverInvoice) => {
  const { month, quinzaine } = date;
  const { lastDate } = getFirstAndLastDate(quinzaine, month, year);
  return ` ${getDateFormat(isDriverInvoice ? date : lastDate)}`;
};
// Date de visionnage et potentiellement de téléchargement du document
export const renderDownloadDate = () => {
  return getDateFormat();
};

export const getTitle = (i, component, totalTitle = false) => {
  const { creditorLegal } = component.props;
  const { isDishopCreditor, serviceBilling } = component.state;
  const outputName = serviceBilling[i][0]?.name
  const name = outputName?.includes('Frais') ? outputName.split('Frais')[1].trim() : outputName || null
  const title = `${totalTitle ? 'Montant dû TTC' : 'Frais'} ${i === PAYMENT_TYPE_STRIPE
    ? 'de transactions'
    : i === DRIVER
      ? 'de livraison'
      : i === ORDER_REFUND
        ? 'remboursement'
        : name ? name
          : isDishopCreditor
            ? 'de services généraux'
            : `${creditorLegal.companyName}`
    }`;

  return title;
};
export const totalMontantDu = object => {
  const tab = _.map(object, elt => elt);
  const sum = _.sumBy(tab, elt => {
    return montantDuByService(elt);
  });
  return sum;
};
export const montantDuByService = service => {
  const sum = _.sumBy(service, 'sumFee');
  return sum;
};

const getFiltredBilling = billings => {
  let dishopOutput = true;
  const filtredBillings = _.filter(billings, billing => {
    const { accounting = {} } = billing;
    return (
      billing.accounting &&
      _.find(accounting.inputs, elt => elt.data) &&
      billing.date &&
      billing.priceOrder > 0
    );
  });
  const lastBillingPerQuinzaine = _.maxBy(
    _.filter(filtredBillings, billing => billing.accounting && billing.accounting.outputs),
    'dateOrder'
  );
  if (lastBillingPerQuinzaine && lastBillingPerQuinzaine.accounting.outputs) {
    dishopOutput = isObjectNotEmpty(
      _.find(lastBillingPerQuinzaine.accounting.outputs, output => output.creditor === DISHOP)
    );
  }
  return { filtredBillings, dishopOutput };
};

const getUniqueValues = (currentBilling, outputKey) => {
  const uniqueArray = [];
  currentBilling.filter(item => {
    const { outputs = {} } = item.accounting;
    if (outputs[outputKey]) {
      const { data = {} } = outputs[outputKey];
      data.servicePrice = removeEmptyStringsFromObject(_.cloneDeep(data.servicePrice));
      const index = uniqueArray.findIndex(elt => {
        return _.isEqual(data.servicePrice, elt);
      });
      if (index <= -1) {
        uniqueArray.push(data.servicePrice);
      }
    }
    return null;
  });
  return uniqueArray.filter(elt => elt && !(elt.variable === '0 %' && elt.fixe === 0));
};

const calculateFees = (billings, outputType, index) => {
  const uniqueValues = getUniqueValues(billings, index ? index : outputType);
  return _.map(uniqueValues, elt => {
    let nbOrder = 0;
    let total = 0;
    let sumFee = 0;
    let contractName = null
    let contract = {};
    _.map(billings, billing => {
      const { accounting } = billing;
      const { outputs = {} } = accounting;
      const output = _.find(outputs, (output, key) => index ? output.type === outputType && index === key : output.type === outputType);
      if (output) {
        const { data = {}, amount = 0 } = output;
        const { amountRef = 0, servicePrice = {}, name } = data;
        if (_.isEqual(servicePrice, elt) && amount > 0) {
          nbOrder++;
          contractName = name;
          total += amountRef;
          sumFee += amount;
        }
      }
    });

    contract = {
      variable: outputType === NETWORK ? elt.variable || 0 : parseFloat(elt.variable.split(' ')[0]),
      fixe: elt.fixe || 0,
      name: contractName,
      nbOrder,
      total,
      sumFee
    };
    return contract;
  });
};

const calculateDriverFees = (billings, outputKey) => {
  const driverFees = [];
  let sumFee = 0;
  _.map(billings, billing => {
    const { accounting } = billing;
    const { outputs = {} } = accounting;
    if (outputs[outputKey]) {
      const { amount = 0 } = outputs[outputKey];
      sumFee += amount;
    }
  });

  if (isIntegerNotNull(sumFee)) driverFees.push({ sumFee });
  return driverFees;
};

const calculateRefundFees = billings => {
  const refundFees = [];
  let sumFee = 0;
  _.map(billings, billing => {
    const { status, priceOrder } = billing;
    if (status === ORDER_REFUND) {
      sumFee += priceOrder;
    }
  });
  if (isIntegerNotNull(sumFee)) refundFees.push({ sumFee });
  return refundFees;
};

export const getServiceBilling = (component, props) => {
  let serviceBilling = {};
  let accountBalance = {};
  const driver = [];
  const { billings, isDriverInvoice, isAllShops } = props;
  if (isDriverInvoice) {
    const { inputs } = billings;
    _.map(inputs, input => {
      const { data = {}, amount } = input;
      const { subjectToVAT } = data;
      driver.push({
        nbOrder: 1,
        fixe: amount,
        sumFee: subjectToVAT ? amount * 1.2 : amount,
        subjectToVAT,
        total: 0
      });
    });

    component.setState({ serviceBilling: { driver } });
  } else {
    const { filtredBillings, dishopOutput } = getFiltredBilling(billings);
    let formatedDefaultContract = [];
    let formatedStripe = [];
    let formatedRefund = [];
    let formatedContracts = [];
    if (dishopOutput) {
      formatedDefaultContract = calculateFees(filtredBillings, DISHOP);
      formatedStripe = calculateFees(filtredBillings, PAYMENT);
      _.map(filtredBillings, (filtredBilling) => {
        return _.keys(filtredBilling?.accounting?.outputs).some((key) => {
          if (key.startsWith(DISHOP) && key !== DISHOP) {
            const index = parseInt(key.split(DISHOP)[1], 10)
            formatedContracts[`contract${index}`]= calculateFees(filtredBillings, DISHOP, key)
          }
        });
      })
    } else {
      formatedDefaultContract = calculateFees(filtredBillings, NETWORK);
    }

    if (!isAllShops) formatedRefund = calculateRefundFees(filtredBillings);
    const formatedDelivery = calculateDriverFees(filtredBillings, DRIVER);
    const emptyInvoice = !(filtredBillings.length > 0);
    const emptyStripe = [
      {
        nbOrder: 0,
        fixe: 0,
        sumFee: 0,
        total: 0,
        variable: 0
      }
    ];

    serviceBilling = {
      contract: formatedDefaultContract,
      ...formatedContracts,
      stripe: emptyInvoice ? emptyStripe : formatedStripe,
      refund: formatedRefund,
      driver: formatedDelivery
    };
    accountBalance = getAccountBalance(filtredBillings);
    component.setState({
      isDishopCreditor: dishopOutput,
      serviceBilling,
      emptyInvoice,
      accountBalance
    });
  }
};

const getAccountBalance = currentBillings => {
  let totalStripe = 0;
  let totalCb = 0;
  let totalCash = 0;
  let total = 0;
  _.map(currentBillings, billing => {
    const { accounting, paymentType } = billing;
    const { inputs } = accounting;
    _.map(inputs, input => {
      const { amount = 0 } = input;
      paymentType === PAYMENT_TYPE_STRIPE
        ? (totalStripe += amount)
        : paymentType === PAYMENT_TYPE_CB
          ? (totalCb += amount)
          : (totalCash += amount);
      total += amount;
    });
  });

  return { totalStripe, totalCash, totalCb, total };
};
